import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  INSIGHT_ID, ITEMS, RULES,
} from 'constants/formFields';
import { createInsightAnswerSchema } from 'utils/validators/MASurveyValidators';

import type { TCreateInsightAnswerSchema } from 'utils/validators/MASurveyValidators';

const useSurveyAnswerForm = () => {
  const {
    control,
    handleSubmit,
    setError,
    formState,
    reset,
    trigger,
  } = useForm<TCreateInsightAnswerSchema>({
    mode: 'onChange',
    resolver: yupResolver(createInsightAnswerSchema),
    defaultValues: {
      [INSIGHT_ID]: 0,
      [ITEMS]: [],
      [RULES]: [],
    },
  });

  const fieldsName = [INSIGHT_ID, ITEMS, RULES];

  return {
    control,
    handleSubmit,
    setError,
    fieldsName,
    formState,
    reset,
    trigger,
  };
};

export default useSurveyAnswerForm;
